/*Add functions to jQuery object. This way they can be used in other js-files*/
import * as toastr from "toastr";
import {isError} from "./functions";
import moment from "moment";

$.fn.customConfirm = function (title, content, action, lang) {

    this.on('click', function (e) {

        console.log(title);

        $.confirm({
            title: title,
            content: content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: action,
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                },
            }
        });
    });
};

export function fnSetDefaultToastr() {//TODO
    toastr.options = {
        positionClass: 'toast-bottom-right'
    }
};

export function setSelect(dataArray, element, value, text, defaultOption) {

    var optionsHtml = '<option value="default">' + defaultOption + '</option>';

    for (var i = 0; i < dataArray.length; i++) {

        var textValue = createTextValue(text, dataArray, i);

        optionsHtml += '<option value="' + dataArray[i][value] + '">' + textValue + '</option>';
    }
    element.html(optionsHtml);
}

export function createTextValue(text, dataArray, index) {

    if (Array.isArray(text)) {

        var arr = [];

        for (var j = 0; j < text.length; j++) {
            arr.push(dataArray[index][text[j]]);
        }
        return arr.join(' - ');
    } else {
        return dataArray[index][text];
    }
}

export function populateSelect(dataArray, element, textKey, valueKey, defaultText) {

    var optionsHtml = '';

    for (var i = 0; i < dataArray.length; i++) {

        var textValue = createTextValue(textKey, dataArray, i);

        optionsHtml += '<option value="' + dataArray[i][valueKey] + '">' + textValue + '</option>';
    }
    element.html(optionsHtml);
}

export function printResponse(response) {

    response.success !== undefined ? toastr.success(response.success) : toastr.error(response.error);
}

export function printToastrWarning(errorMessages) {
    toastr.options = {
        positionClass: 'toast-bottom-right',
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
    };

    toastr.warning(errorMessages);

    resetToastrOptions();
}

export function resetToastrOptions() {
    toastr.options = {
        positionClass: 'toast-bottom-right'
    }
}

export function validateCompany(lang, options) {

    var company_id = getSelectedCompany();

    if (company_id === 'default') {

        toastr.error(lang.company_id);
    } else {
        $.confirm(options)
    }
}

export function toggleLoader(element, showLoader) {

    if (showLoader) {
        $(element).parent().addClass('hidden');
        $(element).parent().parent().find('.loader-col').removeClass('hidden');
    } else {
        $(element).parent().removeClass('hidden');
        $(element).parent().parent().find('.loader-col').addClass('hidden');
    }
}

export function getSelectedCompany() {
    return $('#selected_company').val();
}

export function getSelectedCompanyForUser() {
    return (getSelectedCompany() ? getSelectedCompany() : $('body').attr('data-company'));
}

export function companyGuard() {
    return getSelectedCompany() === 'default';
}

/**
 * Add selectedCompanyEventHandler
 * @param setClients
 */
export function addSelectedCompanyHandler(setClients) {
    $('#selected_company').on('company-changed', setClients);
}

export function toggleDatatable(showTable, tableName) {

    if (showTable) {
        $(tableName).parents('.table-responsive').removeClass('hidden');
    } else {
        $(tableName).parents('.table-responsive').addClass('hidden');
    }
}

export function addFormControlSelect2() {
    $('.select2').find('input').addClass('form-control');
    $('.select2').find('select').addClass('form-control');
}

export function downloadResource(url) {
    setTimeout(function () {
        document.location.href = url;
    }, 250);
}

export function checkIfValidSelect(element) {
    var selectedAccount = parseInt(element.val());

    if (isNaN(selectedAccount)) {
        element.focus();
        element.parent().addClass('is-focused');
        element.siblings('.bmd-help.help-block').addClass('text-danger');
        return false;
    }
    element.parent().removeClass('is-focused');
    element.siblings('.bmd-help.help-block').addClass('text-danger');
    return true;
}

export function resetForm(form, notBtn) {

    var exclude = '';

    if (notBtn) {
        exclude = "input[name='_token'], :submit";
    } else {
        exclude = "input[name='_token']";
    }
    form.find("input").not(exclude).val("");
    form.find("textarea").not(exclude).val('');
    form.find("select").prop('selectedIndex', 0);
    form.find(".bmd-form-group").removeClass('is-filled is-focused');
    form.find('.error-list').html('');
    form.find("#has_roger_ai").val('1');/*Default roger to one*/
}

/*Standard behaviour of checkbox*/
$(document).delegate('.checkbox input', 'click', function () {

    $(':checkbox').prop('checked', function (i, value) {
        return value;
    });
});

export function pjaxRefreshPage() {
    console.log('trying to refresh');
    $.pjax.reload({container: '#pjax-container'});
}

/**
 * Return a theme styled checkbox and with label and checked if checked
 * @param name
 * @param value
 * @param checked
 * @param className
 * @param id
 * @returns {string}
 */
export function createThemeCheckBox(name, value, checked, className, id) {

    return '<span class="form-group bmd-form-group is-filled"><div class="checkbox ' + className + '"><label><input id="' + id + '" name="' + name + '" value="' + value + '" type="checkbox"' + checked + '><span class="checkbox-decorator"><span class="check"></span></span>' + name + '</label></div></span>';
}

export function createThemeCheckBoxSeparateLabel(name, value, checked, className, id, labelText) {

    return '<span class="form-group bmd-form-group is-filled"><div class="checkbox ' + className + '"><label><input id="' + id + '" name="' + name + '" value="' + value + '" type="checkbox"' + checked + '><span class="checkbox-decorator"><span class="check"></span></span>' + labelText + '</label></div></span>';
}

export function validateVoucherLimit(lang, currentSum, callback) {

    var voucher_limit = $('#voucher_limit').text();

    var agreementHtml = '';
    var isOverLimit = currentSum > voucher_limit && voucher_limit !== undefined && voucher_limit !== '';

    callback(isOverLimit);

    if (isOverLimit) {
        /*Do stuff*/
        var label = lang.limit_agreement;
        agreementHtml = '<br><br>' + lang.limit_amount + voucher_limit + '<br><div class="container"><div class="row"><div class="col-sm-8 col-xs-12 col-centered">' + createThemeCheckBox(label, 0, '', 'checkbox-white', 'accept-agreement') + '</div></div></div></div>';
    }
    return agreementHtml;
}

export function reloadVouchersTableWithMissingVoucherText() {
    $('#datatable-vouchers').DataTable().ajax.reload(setMissingVoucherText, false);
}

export function setMissingVoucherText() {

    var lang = allLangFiles.vouchers.js;

    var table = $('#datatable-vouchers').DataTable();

    var data = table.data();
    var recordsTotal = table.page.info().recordsTotal;
    var recordsLeft = 0;
    var element = $('.missing-vouchers-text');
    var hide = true;

    for (var i = 0; i < data.length; i++) {

        if (data[i].uploaded === 0) {
            recordsLeft++;
        }
    }

    var recordsValue = recordsTotal - recordsLeft;

    if (recordsLeft > 0) {
        element.html(lang.still_missing + ' <strong id="missing-amount">' + recordsLeft + '</strong> ' + lang.vouchers);
    } else {
        element.html(lang.missing_voucher_text_default);
        hide = false;
    }

    $('#vouchers-left').html(recordsLeft);
    $('#vouchers-total').html(recordsTotal);

    if (recordsTotal > 0) {
        const progressWidth = (recordsLeft / recordsTotal) * 100;

        $('#progress-fill-voucher').attr('style', `width: ${progressWidth}%;`);
    }

    hide ? $('#btn-close-period').hide() : $('#btn-close-period').show();

}

export function handleErrors(response) {
    var errorMessages = response.errorMessages;
    var lengthErrors = errorMessages.length;
    if (lengthErrors > 0) {

        for (var i = 0; i < lengthErrors; i++) {
            printToastrWarning(errorMessages[i]);
        }
    }
}

export function formatDate(date) {

    //TODO Change to d,m,Y

    // Split timestamp into [ Y, M, D, h, m, s ]
    var t = date.split(/[- :]/);

    // Apply each element to the Date function
    var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));

    console.log(d);

    return d;
}

export function subLangPlaceHolder(langKey, placeholder, value) {

    return langKey.replace(placeholder, value);
}

export function addExportBtns(table) {
    new $.fn.dataTable.Buttons(table.DataTable(), {
            buttons: getDtButtons()
        }
    );
    addButtonStyling(table.DataTable());
}

export function addCustomExportBtns(table, exportColumns, titlePrefix) {
    var title = titlePrefix + '_' + moment().format("YYYY-MM-DD");
    new $.fn.dataTable.Buttons(table.DataTable(), {
            buttons: [
                {
                    extend: 'excel',
                    exportOptions: {
                        columns: exportColumns
                    },
                    title: title
                },
                {
                    extend: 'pdf',
                    exportOptions: {
                        columns: exportColumns
                    },
                    title: title
                },
                {
                    extend: 'csv',
                    exportOptions: {
                        columns: exportColumns
                    },
                    title: title
                },
                {
                    extend: 'copy',
                    exportOptions: {
                        columns: exportColumns
                    },
                    title: title
                },
                {
                    extend: 'print',
                    exportOptions: {
                        columns: exportColumns
                    },
                    title: title
                },
            ]
        }
    );
    addButtonStyling(table.DataTable());
}


export function addButtonStyling(table) {
    $('.btn-export-table').show();
    $('.dropdown_export').html('');
    table.buttons().container().appendTo($('.dropdown_export'));

    $(".buttons-excel, .buttons-pdf, .buttons-copy, .buttons-print, .buttons-csv").addClass("dropdown-item");
    $(".buttons-excel, .buttons-pdf, .buttons-copy, .buttons-print, .buttons-csv").removeClass("dt-button");

    $(".buttons-excel span").before("<i class='material-icons icon'>grid_on</i>");
    $(".buttons-pdf span").before("<i class='material-icons icon'>description</i>");
    $(".buttons-copy span").before("<i class='material-icons icon'>content_copy</i>");
    $(".buttons-print span").before("<i class='material-icons icon'>print</i>");
    $(".buttons-csv span").before("<i class='material-icons icon'>line_style</i>");

    //Hack, all but last group of buttons if multiple exists.
    $('.dropdown_export').find('.dt-buttons:not(:last-child)').hide();
}

export function getDtButtons() {
    return [
      {
        extend: "excelHtml5",
        footer: true,
        //this overwrites the standard styling for footer cells in buttons.html5.js which sets the row to have a styling of only bold.
        customize: function (xlsx) {
            var styleSheet = xlsx.xl['styles.xml'];
            var lastXfIndex = $('cellXfs xf', styleSheet).length - 1;
            //custom styling: Right alignment, bold, two decimal places.
            var numberFormatTwoDecimalBold = '<xf numFmtId="4" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
            '<alignment horizontal="right"/></xf>'
            //custom styling: Right alignment, two decimals for numbers with thousandsseparator
            var numberFormatRightAlignedThousandsSeparator = '<xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
            '<alignment horizontal="right"/></xf>'
            styleSheet.childNodes[0].childNodes[5].innerHTML += numberFormatTwoDecimalBold + numberFormatRightAlignedThousandsSeparator;
            var twoDecPlacesBold = lastXfIndex + 1;
            var thousandsSeparatorRightAligned = lastXfIndex + 2;
            var sheet = xlsx.xl.worksheets['sheet1.xml'];
            var rows = $('row', sheet); //get all rows
            //iterate over all rows except last row (last row is the footer row) and apply custom styling to the cells
            for (var i = 0; i < rows.length - 1; i++) {
                $('row:eq('+i+') c', sheet).attr( 's', thousandsSeparatorRightAligned);
            }
            //apply custom styling to the footer row 
            $('row:last c', sheet).attr( 's', twoDecPlacesBold ); 

            let styles = xlsx.xl['styles.xml'];
            let stylesCount = parseInt($( 'cellXfs', styles ).attr("count"), 10);
            addCellColorStyles(styles, stylesCount);

            // use new styles:
            highlightCells(sheet, stylesCount);

        },
        exportOptions: {
        columns: [
            ':not(.not-export)', //ensures the column 'Actions' is not included in export.
        ], 
          format: {
            body: function(data, row, column, node) {
                data = $('<p>' + data + '</p>').text();
                if(data.includes(',') && !data.includes('.')){
                    return data.replace(',', '.');
                }
                return data.trim();
            },
            footer: function(data, row, column, node) {
                data = $('<p>' + data + '</p>').text();
                if(data.includes(',') && !data.includes('.')){
                    return data.replace(',', '.');
                }
                return data.trim();
            },
        }, 
        },  
      },
      {
        extend: "pdf",
        orientation: "landscape",
        pageSize: "LEGAL",
        footer: true,
        exportOptions: {
            columns: ':not(.not-export)', //ensures the column 'Actions' is not included in export.
        },
        customize: function(doc) {
            highlightCellsPdf(doc);
        }
      },
      {
        extend: "csv",
        footer: true,
        exportOptions: {
            columns: ':not(.not-export)', //ensures the column 'Actions' is not included in export.
        },
      },
      {
        extend: "copy",
        footer: true,
        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "print",
        footer: true,
        exportOptions: {
          columns: ":visible",
        },
        customize: function(win) {            
            highlightCellsPrint(win);
        }
      },
    ];
}

var myFontColors = [
'548235', // idx 0 - mustard
'ffc000', // idx 1 - dark green
'000000', // idx 2 - black
'ffffff'  // idx 3 - white
];

var myFillColors = [
'548235', // idx 0 - mustard
'ffc000', // idx 1 - dark green
'ff0000'  // idx 2 - red
];

var myCellStyles = [
{ fontIdx: 0, fillIdx: 1 }, // idx 0 - mustard on green
{ fontIdx: 1, fillIdx: 0 }, // idx 1 - green on mustard
{ fontIdx: 2, fillIdx: 2 }, // idx 2 - black on red
{ fontIdx: 3, fillIdx: 2 }  // idx 3 - white on red
];

export function addCellColorStyles(styles, stylesCount) {
    // add font styles:
    let fontsCount = parseInt($( 'fonts', styles ).attr("count"), 10);
    myFontColors.forEach((color) => {
        $( 'fonts', styles ).append( fontTmplt(color.toUpperCase()) );
    });
    $( 'fonts', styles ).attr("count", (fontsCount + myFontColors.length).toString());

    // add fill styles:
    let fillsCount = parseInt($( 'fills', styles ).attr("count"), 10);
    myFillColors.forEach((color) => {
        $( 'fills', styles ).append( fillTmplt(color.toUpperCase()) );
    });
    $( 'fills', styles ).attr("count", (fillsCount + myFillColors.length).toString());

    // add cell styles:
    myCellStyles.forEach((style) => {
        $( 'cellXfs', styles ).append( cellXfTmplt(fontsCount + style.fontIdx, fillsCount + style.fillIdx) );
    });
    $( 'cellXfs', styles ).attr("count", (stylesCount + myCellStyles.length).toString());
}

export function highlightCells(sheet, stylesCount) {
    $( '#datatable-payroll' ).dataTable().api().rows().nodes().each(function(trNode, rowIdx) {
        var xlRow = rowIdx + 3; // +1 for DT zero index; +1 for title row; +1 for row heading in Excel
        $.each( $( 'td', $(trNode) ), function( index, tdNode ) {
            var bgColor = $(tdNode).css("background-color");
            if ( bgColor && bgColor === 'rgb(144, 238, 144)' ) {
                let xlCol = createXlColLetter(index);
                let xlRef = xlCol + xlRow;
                let cellSelector = 'c[r=' + xlRef + ']';
                let cellStyle = 3; // 3 is my custom style index for white on red
                let cellStyleID = (stylesCount + cellStyle).toString(); 
                $(cellSelector, sheet).attr( 's', 40 );
            }
        });
    }); 
}

/**
 * Function to highlight cells in the pdf export if the background color of the cell is green in the html table.
 * @param {} docs 
 */
export function highlightCellsPdf(docs){
    $( '#datatable-payroll' ).dataTable().api().rows().nodes().each(function(trNode, rowIdx) {
        var pdfRow = rowIdx + 1;
        $.each( $( 'td', $(trNode) ), function( index, tdNode ) {
            var bgColor = $(tdNode).css("background-color");
            if (bgColor && bgColor === 'rgb(144, 238, 144)' ) {
                var pdfCol = index;
                var pdfCell = docs.content[1].table.body[pdfRow][pdfCol];
                pdfCell.fillColor = '#90EE90';
            }
        });


    });
}

/**
 * Function to highlight cells in the print export if the background color of the cell is green in the corresponding table.
 * Highlights with font color instead of background color as print export strips background color.
 * @param {} win window object for the new window. Document body can be accessed and manipulated using jQuery/DOM methods.
 */
export function highlightCellsPrint(win){
    $( '#datatable-payroll' ).dataTable().api().rows().nodes().each(function(trNode, rowIdx) {
        var printRow = rowIdx + 1;
        $.each( $( 'td', $(trNode) ), function( index, tdNode ) {
            var bgColor = $(tdNode).css("background-color");
            if (bgColor && bgColor === 'rgb(144, 238, 144)' ) {
                var printCol = index;
                var printCell = $(win.document.body).find('table').find('tr').eq(printRow).find('td').eq(printCol);
                printCell.css('color', '#90EE90');
            }
        });
    });
}

function createXlColLetter( n ){
    var ordA = 'A'.charCodeAt(0);
    var ordZ = 'Z'.charCodeAt(0);
    var len = ordZ - ordA + 1;
    var s = ""; 
    while( n >= 0 ) {
        s = String.fromCharCode(n % len + ordA) + s;
        n = Math.floor(n / len) - 1;
    }
    return s;
}
  
// style templates
function fontTmplt(color) {
    return `<font><sz val="11" /><name val="Calibri" /><color rgb="${'FF' + color}" /></font>`;
}
function fillTmplt(color) {
    return `<fill><patternFill patternType="solid"><fgColor rgb="${'FF' + color}" /><bgColor indexed="64" /></patternFill></fill>`;
}
function cellXfTmplt(fontIdx, fillIdx) {
    return `<xf numFmtId="0" fontId="${fontIdx}" fillId="${fillIdx}" borderId="0" applyFont="1" applyFill="1" applyBorder="1" />`;
}
  
export function fnFooterCallback(row, data, start, end, display) {
    var api = this.api(), data;
    // Remove the formatting to get integer data for summation
    var intValue = function (i) {
        return typeof i === 'string' ?
            i.replace(/[\$,]/g, '') * 1 :
            typeof i === 'number' ?
                i : 0;
    };

    // Total over all pages
    var total = api
        .column(2)
        .data()
        .reduce(function (a, b) {
            return intValue(a) + intValue(b);
        }, 0);

    console.log(api.column(2).data());
    console.log(total);

    // Update footer
    $(api.column(2).footer()).html(total);
}

export function getSelectedRowData(dataTable) {
    return dataTable.rows('.selected').data();
}


export function dropzoneExists(selector) {
    var elements = $(selector).find('.dz-default');

    return elements.length > 0;
}

export function createDropzoneMockfile(fileUrl, myDropzone, errorHandler, unauthorizedErrorHandler) {

    $.ajax({
        type: 'GET',
        url: fileUrl,
        success: function (response) {

            if (response.data !== undefined) {

                /*Deleting and trying to upload creates a looop...............*/
                var mockFile = {name: response.data.filename, size: response.data.size, status: 'mockFile', url: response.data.url};

                // Call the default addedfile event handler
                myDropzone.emit("addedfile", mockFile);

                myDropzone.files.push(mockFile);
                // Make sure that there is no progress bar, etc...
                myDropzone.emit("complete", mockFile);

                myDropzone.emit("thumbnail", mockFile, "/img/pdf.png");
            } else {
                errorHandler(response);
            }
        },
        error: function (error) {
            fnToastrFormError(error);
            if (error.status === 403) {
                unauthorizedErrorHandler()
            }
        }
    });
}

export function createDropzoneMockfiles(fileUrl, myDropzone, errorHandler, unauthorizedErrorHandler) {

    $.ajax({
        type: 'GET',
        url: fileUrl,
        success: function (response) {

            if (response.data !== undefined) {

                for (let i = 0; i < response.data.length; i++) { /*Deleting and trying to upload creates a looop...............*/
                    let file = response.data[i];
                    let mockFile = {name: file.filename, size: file.size, status: 'mockFile', url: file.url, file_id: file.file_id};

                    // Call the default addedfile event handler
                    myDropzone.emit("addedfile", mockFile);

                    myDropzone.files.push(mockFile);

                    // Make sure that there is no progress bar, etc...
                    myDropzone.emit("complete", mockFile);

                    myDropzone.emit("thumbnail", mockFile, "/img/pdf.png");
                }
            } else {
                errorHandler(response);
            }
        },
        error: function (error) {
            fnToastrFormError(error);
            if (error.status === 403) {
                unauthorizedErrorHandler()
            }
        }
    });
}


export function fnErrorMsg(jqXHR, textStatus, errorThrown) {

    console.log(JSON.stringify(jqXHR));
    console.log('AJAX error:' + textStatus, ' : ' + errorThrown);
}

export function appendXSelectedCompanyHeader(xhr) {
    let selectedCompany = getSelectedCompanyForUser();

    if (!selectedCompany || selectedCompany === 'default') return;

    xhr.setRequestHeader("X-SELECTED-COMPANY", selectedCompany);
}

export function fnToastrFormError(data) {
    var errors = '';
    for (var datos in data.responseJSON.errors) {
        errors += data.responseJSON.errors[datos] + '<br>';
    }
    if (data.status == 403) {
        toastr.error(allLangFiles.forms.unauthorized);
    }
    if (data.status == 500) {
        toastr.error(allLangFiles.forms.system_error);
    }
    if (errors != '') {
        toastr.error(errors);
    }
}

export function listFormError(data, element) {

    var errors = '<ul class="list-group-item-danger">';
    for (var datos in data.responseJSON.errors) {
        errors += '<li class="list-group-item-danger">' + data.responseJSON.errors[datos] + '</li>';
    }
    errors += '</ul>';

    element.html(errors);
}

export function toggleClassOnWidth(element, className, width) {

    $(window).innerWidth() < width
        ? element.removeClass(className)
        : element.addClass(className);
}

export function popupCenterDual(url, title, w, h) {
// Fixes dual-screen position Most browsers Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

// Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}

export function dropdownFix(context) {
    if ($('body').hasClass('modal-open')) {
        throw new Error("This solution is not working inside a responsive table inside a modal, you need to find out a way to calculate the modal Z-index and add it to the element");
        return true;
    }

    var buttonGroup = $(context).parent();

    if (!buttonGroup.attr('data-attachedUl')) {
        var ts = +new Date;
        var div = $(context).siblings('div');

        div.attr('data-parent', ts);
        buttonGroup.attr('data-attachedUl', ts);
        $(window).resize(function () {
            div.css('display', 'none').data('top');
        });
    } else {
        div = $('[data-parent=' + buttonGroup.attr('data-attachedUl') + ']');
    }
    if (!buttonGroup.hasClass('open')) {

        div.css('display', 'none');
        return;
    }
    dropDownFixPosition($(context).parent(), div);


    function dropDownFixPosition(button, dropdown) {

        var dropDownTop = button.offset().top + button.outerHeight();
        dropdown.css('top', dropDownTop + "px");
        dropdown.css('left', button.offset().left + "px");
        dropdown.css('position', "absolute");

        dropdown.css('width', dropdown.width());
        dropdown.css('display', 'block');
        dropdown.css('opacity', '1');
        dropdown.css('-webkit-transform', 'scale(1)');
        dropdown.css('transform', 'scale(1)');
        dropdown.appendTo('.dashboard-dropdown-container');
    }
}

export function updateDataTableNewUrl(table, selectedCompanyId, callback) {

    var existingUrl = table.DataTable().ajax.url();
    var element = existingUrl.split('/');
    var newElement = element.splice(0, 4);

    var updatedUrl = newElement.join('/') + '/' + selectedCompanyId;

    table.DataTable().clear();
    table.DataTable().ajax.url(updatedUrl);
    table.DataTable().ajax.reload(callback, false);

    console.log('reload');
}

export function popupCenter(url, title, w, h) {
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}

export function handleFormErrorServerSide(tabPaneId, name, errorMsg, isFirst) {

    var elementSearch = 'input[name="' + name + '"]';
    $('.nav-link ' + elementSearch).removeClass('active');

    isError($(elementSearch), errorMsg);

    if (isFirst) {
        var errorTab = $('.nav-link.' + tabPaneId + '-tab');
        errorTab.tab('show');
        errorTab.addClass('active');
    }
}

export function padLeft(number, length, padWithCharacter) {
    return Array(length - String(number).length + 1).join(padWithCharacter || '0') + number;
}

export function toggleSpinner(container) {

    $('#loadingSpinner').parents('.loader-col').toggleClass('hidden');
    $(container).toggleClass('hidden');
}

export function toggleSpinnerByParent(parent, container) {

    parent.find('#loadingSpinner').parents('.loader-col').toggleClass('hidden');
    $(container).toggleClass('hidden');
}

export function pjaxPost(data, url) {


    $.pjax({
        type: 'POST',
        data: data,
        url: url,
        container: '#pjax-container',
        success: function (response) {
            console.log(response);
        },
        error: fnToastrFormError,
    });
}

export function pjaxRedirect(url) {
    $.pjax({
        url: url,
        container: '#pjax-container'
    });
}

export function setThemeDropdown(element, select) {

    var selectedText = element.text();
    var selectedId = element.attr('value');

    element.parents('#selected_salary-sheet').find('.dropdown-toggle').html(selectedText);
    select.attr('value', selectedId);
}

export function expandableColumn() {
    return {
        "className": 'details-control',
        "orderable": false,
        "data": null,
        "defaultContent": ''
    };
}

export function addExpandableColumnListener(tableName, table) {

    var id;

    $(tableName + ' tbody').off('click', 'tr.even, tr.odd');
    $(tableName + ' tbody').on('click', 'tr.even, tr.odd', function (e) {
        if ($(e.target).is(".employee_field_button") || $(e.target).is('.data_button') || $(e.target).is('.payroll_done') || $(e.target).is('.btn_payroll_status')) {
            return true;
        }

        e.stopPropagation();

        var tr = $(this);
        var row = table.row(this);

        id = row.data().status_id;

        loadStatusColumn(row, tr, id, false);

        //Move out?
        $(document).off('submit', '.form-status-comment');
        $(document).on('submit', '.form-status-comment', function (e) {

            e.preventDefault();

            var url = this.action;
            var data = $(this).serialize();

            var tr = $(this).closest('table').closest('tr').prev();
            var row = table.row(tr);

            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                success: function (response) {

                    printResponse(response);

                    loadStatusColumn(row, tr, id, true);
                },
                error: fnToastrFormError
            });
        });

        $(document).off('click', '.btn-delete-comment');
        $(document).on('click', '.btn-delete-comment', function (e) {

            e.preventDefault();

            var tr = $(this).closest('table').closest('tr').prev();
            var row = table.row(tr);

            $.ajax({
                type: 'DELETE',
                url: '/dashboard/admin/comments/' + $(this).attr('data-id'),
                success: function (response) {

                    printResponse(response);

                    loadStatusColumn(row, tr, id, true);
                }
            });
        });

    })
        .children().on('click', function (e) {
        e.preventDefault();
    });
}

export function localeFormattedNumber(number) {
    if (!number) return '';

    return parseFloat(number).toLocaleString('da', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export function dtTooltipName(varLength, varMaxWidth) {

    var length = varLength !== undefined ? varLength : 25;
    var maxWidth = varMaxWidth !== undefined ? varMaxWidth : 1440;

    return {
        data: 'name',
        render: function (data, type, row) {

            var width = window.innerWidth;
            var lengthAdjusted = length - (Math.round(width / 100));
            var condition = (maxWidth > width && width > 1199 && data.length > lengthAdjusted);

            /*console.log(Math.round(width / 200));
             console.log(length);
             console.log(lengthAdjusted);
             console.log(width);*/
            var value = condition
                ? data.substr(0, lengthAdjusted).trim() + '...'
                : data;

            return elTooltip(data, value);
        }
    }
}

export function elTooltip(data, value) {

    return '<div class="company-tooltips" data-toggle="tooltip" ' +
        'data-placement="bottom" ' +
        'title="' + data + '">' + value +
        '</div>'
}

export function addCompanyTooltips(settings) {

    var api = this.api();

    /* Apply the tooltips */
    $('td > div.company-tooltips', api.table().container()).tooltip({
        container: 'body',
        show: {delay: 250, duration: 0},
        tooltipClass: "custom-tooltip",
    });

}

export function loadStatusColumn(row, tr, id, refresh) {

    if (row.child.isShown() && !refresh) {
        row.child.hide();
        tr.removeClass('shown');
    } else {

        var data = row.data();

        if (data === undefined) return false;

        $.ajax({
            url: '/dashboard/admin/status/' + id,
            success: function (response) {
                row.child(response).show();
                tr.addClass('shown');
            },
            error: fnToastrFormError,
        })
    }
}

export function formatExpandableColumn(rowData, lang) {

    if (rowData === undefined) return false;
    console.log(rowData);
    // `rowData` is the original data object for the row
    return '<table class="expandable-table-column" cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%; ">' +
        '<tr>' +
        '<td style="width: 29.5%;">' + lang.employees + '</td>' +
        '<td>' + rowData.name + '</td>' +

        '</tr>' +
        '<tr>' +
        '<td>' + lang.comment_by + '</td>' +
        '<td>' + rowData.name + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>' + lang.comment_by + '</td>' +
        '<td><input name="comment" id="comment" value="' + rowData.name + '"></td>' +
        '</tr>' +
        '<tr>' +
        '<td>' + lang.actions + '</td>' +
        '<td>' +
        '<button class="btn btn-success btn-save-comment" style="font-size: 12px">' + lang.update + '</button>' +
        '<button class="btn btn-primary btn-save-comment m-l-10" style="font-size: 12px">' + lang.new + '</button>' +
        '</td>' +
        '</tr>' +
        '</table>';
}

export function addTopSearchColumn(tableName, table) {

    var count = 0;

    $(tableName + '_wrapper thead tr.filters th').each(function () {

        var noFilter = $(this).attr('class');

        var searchString = 'not-searchable';
        var notSearchable = $(this).hasClass(searchString) ? searchString : '';

        count++;

        if (notSearchable) {
            count++;
        }

        if (noFilter !== 'no_filter') {
            var title = $(tableName + ' thead th').eq($(this).index()).text();
            //Add counter for
            $(this).html('<input class="form-control ' + notSearchable + '" type="text" placeholder="Filter ' + title + '" data-searchable-col="' + count + '" />');
        }
    });

    // DataTable
    // Apply the filter
    $(table.table().container()).on('keyup change', 'thead input', function () {

        /*One hidden field, so add 1*/
        //var index = $(this).parent().index();

        var index = parseInt($(this).attr('data-searchable-col'));

        table
            .columns(index)
            .search(this.value)
            .draw();

        var info = table.page.info();
        var count = info.recordsTotal;
        $('#entries').text('Entries:  ' + info.recordsDisplay);
    });
}

export function addSearchColumn(tableName, table) {

    $(tableName + ' tfoot th').each(function () {
        var noFilter = $(this).attr('class');

        var searchString = 'not-searchable';
        var notSearchable = $(this).hasClass(searchString) ? searchString : '';

        if (noFilter != 'no_filter') {
            var title = $(this).text();
            $(this).html('<input class="form-control ' + notSearchable + '" type="text" placeholder="Filter ' + title + '" />');
        }
    });

    $(tableName + " tfoot input").off().on('keyup change', function () {

        /*console.log(table.column($(this).parent().index() + ':visible')
         .data().filter());
         console.log($(this).parent().parent().children('.employee_field_button').text());*/
        var isDropdown = $(this);
        console.log(isDropdown);

        /*One hidden field, so add 1*/
        var index = $(this).parent().index() + 1;

        console.log($(this).hasClass('not-searchable'))

        if ($(this).hasClass('not-searchable')) {
            //add one to index to search value field - not dropdown field
            index++;
        }

        table
            .columns(index)
            .search(this.value)
            .draw();

        var info = table.page.info();
        var count = info.recordsTotal;
        $('#entries').text('Entries:  ' + count);
    });
}

export function isUserClient(companyIds, company_id) {
    if (!$.isArray(companyIds)) {
        companyIds = companyIds.split(',');
    }
    return companyIds.indexOf(company_id) !== -1;
}

export function addMultiSelect(element, customLang, columns, selectAll) {

    var lang = allLangFiles.roles.select;

    element.multiselect({
        columns: columns,
        placeholder: customLang.placeholder,
        search: true,
        searchOptions: {
            'default': customLang.search_options.default
        },
        selectAll: selectAll,
        texts: {
            placeholder: lang.texts.placeholder,
            search: lang.texts.search,
            selectedOptions: lang.texts.selectedOptions,
            selectAll: lang.texts.selectAll,
            unselectAll: lang.texts.unselectAll,
            noneSelected: lang.texts.noneSelected,
        }
    });
}

export function setSelectionMultiSelect(rowData, element) {

    $.each(rowData, function (index, value) {
        var id = value.id;
        element.find('option[value="' + id + '"]').prop('selected', true);
    });
}

export function toggleDisplaySelectClient(show) {

    const display = $('#display-select-client');

    if (show) {
        display.removeClass('hidden');
    } else {
        display.addClass('hidden');
    }
}
